import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		lstOfw: [],
		ofw: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lastUpdatedRegister: null,
	},
	getters: {
		getUpdate(state) {
			return state.update
		},
		getOfw(state) {
			let ofw = { ...state.ofw }
			return ofw
		},
		getOfwcodins(state) {
			return state.ofw.ofwcodins
		},
		getSearch(state) {
			return state.search
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
	},
	mutations: {
		set(state, ofw) {
			state.ofw = ofw
			if (ofw) state.update = true
		},
		initForm(state) {
			state.insert = false
			state.update = false
			state.ofw = null
		},
		setParamsDataTable(state, payload) {
			state.lstOfw = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setOfw(state, ofw) {
			state.ofw = ofw
		},
		setLstOfw(state, lstOfw) {
			state.lstOfw = lstOfw
		},
		setHasNext(state, hasNext) {
			state.hasNext = hasNext
		},
		setSearch(state, search) {
			state.search = search
		},
		setLastUpdatedRegister(state, lastUpdatedRegister) {
			state.lastUpdatedRegister = lastUpdatedRegister
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async search({ commit, getters, dispatch }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			let payload = await this._vm.$axios
				.get(`/OryxPlace/RawMaterialParameter/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
					return true
				})
				.catch(error => {
					commit("setLstOfw", [])
					commit("setSearch", "")
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			commit("setLoading", false)
			return payload
		},
		async find({ commit, dispatch }, ofwcodins) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/OryxPlace/RawMaterialParameter/Find/${ofwcodins}`)
				.then(response => {
					let ofw = Utils.ValidateAxiosResponse(response.data)
					commit("set", ofw)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
			commit("setLoading", false)
		},
		async findRequiredList({ commit, dispatch }) {
            commit("setLoading", true)
            await this._vm.$axios.get("/OryxPlace/RawMaterialParameter/FindRequiredList/")
                .then(response => {
                    let lstOfw = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstOfw", lstOfw)
                }).catch(error => {
                    commit("setLstOfw", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
		async get({ dispatch }, ofwcodins) {
			return await this._vm.$axios
				.get(`/OryxPlace/RawMaterialParameter/Find/${ofwcodins}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return null
				})
		},
		async save({ getters, dispatch }) {
			if (getters.getUpdate) {
				return await dispatch("update")
			}
			return await dispatch("insert")
		},
		async insert({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.post("/OryxPlace/RawMaterialParameter/Insert", getters.getOfw)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					commit("setOfw", null)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ commit, getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
				{ root: true },
			)
			let payload = await this._vm.$axios
				.put("/OryxPlace/RawMaterialParameter/Update", getters.getOfw)
				.then(response => {
					commit("setLastUpdatedRegister", Utils.ValidateAxiosResponse(response.data))
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ getters, dispatch }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/OryxPlace/RawMaterialParameter/Delete/${getters.getOfwcodins}`)
				.then(response => {
					Utils.ValidateAxiosResponse(response.data)
					return true
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
